module.exports = __webpack_public_path__ + "assets/1792649897182/img/center-logo.67e4770a.png";